import React from "react";
import {
    Authenticator,
    buildCollection,
    CMSApp,
    EntityCollection,
    Navigation,
    NavigationBuilder,
    NavigationBuilderProps
} from "@camberi/firecms";

import firebase from "firebase";


import { firebaseConfig } from "../firebase_config";
import logo from "./images/zenmind.png";

import { customSchemaResolver } from "./custom_schema_resolver";
import faqSchema from "./schemas/faqSchema";
import adminSchema from "./schemas/adminSchema";
import categorySchema from "./schemas/categorySchema";
import courseSchema from "./schemas/courseSchema";
import eventSchema from "./schemas/eventSchema";
import sessionSchema from "./schemas/sessionSchema";
import settingSchema from "./schemas/settingSchema";
import teacherSchema from "./schemas/teacherSchema";
import userSchema from "./schemas/userSchema";
import packageSchema from "./schemas/packageSchema";
import dailySessionSchema from "./schemas/dailySessionSchema";
import companySchema from "./schemas/companySchema";


function SampleApp() {


    const faqCollection: EntityCollection<typeof faqSchema> =
        buildCollection({
            name: "FAQ",
            relativePath: "faqs",
            schema: faqSchema,
            filterableProperties: ["question", "answer"],
            inlineEditing: false,

        });
    const adminCollection: EntityCollection<typeof adminSchema> =
        buildCollection({
            group: "Users",
            name: "Admin",
            relativePath: "admins",
            schema: adminSchema,
            filterableProperties: ["name", "email"],
            inlineEditing: false,
            exportable: false,

        });

        const companyCollection: EntityCollection<typeof companySchema> =
        buildCollection({
            group: "Users",
            name: "Company",
            relativePath: "companies",
            schema: companySchema,
            filterableProperties: ["name"],
            inlineEditing: false,
            exportable: false,

        });

    const categoryCollection: EntityCollection<typeof categorySchema> =
        buildCollection({
            name: "Category",
            relativePath: "categories",
            schema: categorySchema,
            inlineEditing: false,

        });

    const courseCollection: EntityCollection<typeof courseSchema> =
        buildCollection({
            name: "Course",
            relativePath: "courses",
            schema: courseSchema,
            inlineEditing: false,
            initialSort: ["updated_at", "desc"],
            // textSearchDelegate: courseSearchDelegate,
            filterableProperties: ["title", "description"],


        });
    const eventCollection: EntityCollection<typeof eventSchema> =
        buildCollection({
            name: "Event",
            relativePath: "events",
            schema: eventSchema,
            inlineEditing: false,


        });

    const sessionCollection: EntityCollection<typeof sessionSchema> =
        buildCollection({
            name: "Session",
            relativePath: "sessions",
            schema: sessionSchema,
            inlineEditing: false,
            filterableProperties: ["title"],

        });

    const packageCollection: EntityCollection<typeof packageSchema> =
        buildCollection({
            name: "Package",
            relativePath: "packages",
            schema: packageSchema,
            inlineEditing: false,
            permissions: {
                create: false,
                delete: false,
            }
        });

    const settingCollection: EntityCollection<typeof settingSchema> =
        buildCollection({
            name: "Setting",
            relativePath: "settings",
            schema: settingSchema,
            inlineEditing: false,
            permissions: {
                create: false,
                edit: true,
                delete: false,
            }

        });

    const teacherCollection: EntityCollection<typeof teacherSchema> =
        buildCollection({
            name: "Teacher",
            relativePath: "teachers",
            schema: teacherSchema,
            inlineEditing: false,

        });

    const userCollection: EntityCollection<typeof userSchema> =
        buildCollection({
            group: "Users",
            name: "User",
            relativePath: "users",
            inlineEditing: false,
            schema: userSchema,
            permissions: {
                create: false,
                delete: false,
                edit: true,
            }
            // inlineEditing: false,
            // permissions:{
            //     edit:false,
            // }

        });

    const dailySessionCollection: EntityCollection<typeof dailySessionSchema> =
        buildCollection({
            name: "Daily Session",
            relativePath: "dailySessions",
            inlineEditing: false,
            schema: dailySessionSchema,

            // permissions: {
            //     create: false,
            //     delete: false,
            //     edit: true,
            // }
            // inlineEditing: false,
            // permissions:{
            //     edit:false,
            // }

        });



    const myAuthenticator: Authenticator = (user?: firebase.User) => {
        var result = firebase.firestore().collection("admins").where('email', '==', user?.email).get().then((v) => !v.empty);

        return result;
    };



    const onFirebaseInit = (config: Object) => {
        // models.firestore().useEmulator("localhost", 8080);
    };

    const navigation: NavigationBuilder = ({ user }: NavigationBuilderProps) => {
        const navigation: Navigation = {
            collections: [

                faqCollection,
                adminCollection,
                categoryCollection,
                courseCollection,
                eventCollection,
                sessionCollection,
                settingCollection,
                teacherCollection,
                userCollection,
                packageCollection,
                dailySessionCollection,
                companyCollection,

            ],
            // views: customViews
        };



        return navigation;
    };

    return <CMSApp
        name={"Zenmind"}
        authentication={myAuthenticator}
        signInOptions={[
            firebase.auth.GoogleAuthProvider.PROVIDER_ID,
            firebase.auth.EmailAuthProvider.PROVIDER_ID
        ]}
        // allowSkipLogin={true}
        logo={logo}
        navigation={navigation}
        schemaResolver={customSchemaResolver}
        firebaseConfig={firebaseConfig}

        onFirebaseInit={onFirebaseInit}
    />;
}

export default SampleApp;

//for firebase deplyment, on example folder 'yarn deploy' command.